import { Icon } from "@trustpilot/constellation-components";
import { Text } from "ilenia";
import React, { FC } from "react";

import { NavHeader, NavHeaderTypography, NavStyledIcon } from "../styled";

interface INavMenuHeaderProps {
  ariaLabel: string;
  icon: string;
  headingLocoKey: string;
  borderBottom?: boolean;
}

export const NavMenuHeader: FC<INavMenuHeaderProps> = ({ ariaLabel, icon, headingLocoKey, borderBottom = true }) => {
  return (
    <NavHeader borderBottom={borderBottom}>
      <NavStyledIcon aria-hidden>
        <Icon content={icon} />
      </NavStyledIcon>
      <NavHeaderTypography variant="heading-m" id={ariaLabel}>
        <Text id={headingLocoKey} />
      </NavHeaderTypography>
    </NavHeader>
  );
};
